import { EmployeeRole } from '@/api/apis/resources';
import { Uuid } from '@/api/types';
import { ResourceWarning, WarningType } from '../types';

export const createMissingShiftWarningHandler = (toggleWarning: (warning: ResourceWarning) => void) => {
  return (employeeId: Uuid, employeeFullName: string | null, employeeRole: EmployeeRole) => {
    const message = `${employeeFullName || ''} is not on an On-Call shift. Are you sure you want to proceed?`;

    const warning: ResourceWarning = {
      id: `${employeeId}:${employeeRole}:${WarningType.MissingShift}`,
      type: WarningType.MissingShift,
      employeeId,
      role: employeeRole,
      message,
    };

    toggleWarning(warning);
  };
};
